import { IFilterConfig, IFilterLabelValue } from "..";

import { ArrowUpward } from "@livechat/design-system-icons";

import { TICKET_PRIORITY_LABEL_MAP } from "constants/tickets/priorities";
import { TicketPriority } from "interfaces/entities/ticket";

export const priorityFilterConfig: IFilterConfig = {
  title: "Priority",
  icon: ArrowUpward,
  multiple: true,
  // @ts-expect-error TS(2322)
  getFilterLabelValues: (filterValues: { priority: string[] } | null): IFilterLabelValue[] => {
    if (filterValues === null) {
      return [];
    }

    return filterValues?.priority.map(priority => {
      const ticketPriority = TICKET_PRIORITY_LABEL_MAP[priority as unknown as TicketPriority] || "Unknown";
      return {
        key: ticketPriority,
        label: ticketPriority,
      };
    });
  },
};
